<script setup lang="ts">
  import { formatNumber } from '@/utils/strings';
  import { computed } from 'vue';

  interface Props {
    title: string;
    value: string | number;
  }

  const props = defineProps<{
    stat: Props;
  }>();

  const icon = computed(() => {
    switch (props.stat.title) {
      case 'reach':
        return 'lucide:users';
      case 'views':
        return 'lucide:eye';
      case 'engagement':
        return 'lucide:trending-up';
      default:
        return '';
    }
  });

  const computedTitle = computed(() => {
    switch (props.stat.title) {
      case 'reach':
        return 'Total Reach';
      case 'views':
        return 'Total Views';
      case 'engagement':
        return 'Engagement Rate';
      default:
        return '';
    }
  });
</script>

<template>
  <div class="details-stat flex items-center justify-between" :class="props.stat.title">
    <div class="text-container flex flex-col gap-8">
      <span class="stat-title">{{ computedTitle }}</span>
      <span class="value">
        {{ `${formatNumber(props.stat.value, { notation: 'compact', fractionDigits: 1 })}${props.stat.title === 'engagement' ? '%' : ''}` }}
      </span>
    </div>
    <div class="icon-container flex items-center justify-center">
      <iconify-icon :icon="icon" />
    </div>
  </div>
</template>

<style scoped lang="scss">
  .details-stat {
    padding: 16px;
    border-radius: 12px;
    text-wrap: wrap;
    color: white;
    width: 100%;
    height: 100%;

    .stat-title {
      font-size: 12px;
    }

    @media screen and (min-width: 768px) {
      padding: 24px;

      .stat-title {
        font-size: 14px;
      }
    }

    .value {
      font-size: 24px;
      font-weight: 700;
    }

    svg {
      width: 32px;
      height: 32px;
    }

    &.reach {
      background: linear-gradient(135deg, rgb(59 130 246), rgb(37 99 235));
    }

    &.views {
      background: linear-gradient(135deg, rgb(14 165 233), rgb(2 132 199));
    }

    &.engagement {
      background: linear-gradient(135deg, rgb(34 197 94), rgb(20 184 166));
    }
  }
</style>
